import { Link, useLoaderData } from 'react-router'
import { MainNavigationMenu } from '#app/components/main-nav.tsx'
import { Icon } from '#app/components/ui/icon'
import { type loader } from '#app/root.tsx'
import { ThemeSwitch } from '#app/routes/_app+/resources+/theme-switch.tsx'
import { UserProfile } from './user-profile'

export function MainHeader() {
	const data = useLoaderData<typeof loader>()
	return (
		<header className="bg-background text-foreground sticky top-0 flex flex-col hover:z-10">
			<div className="flex items-center justify-between gap-4 p-6 pb-0 md:gap-8">
				<Icon
					className="text-secondary-foreground size-14 min-w-14"
					name="cwf"
				/>
				<Link
					to="/"
					className="group flex flex-wrap items-center leading-snug md:max-2xl:hidden"
				>
					<span className="text-lg font-bold transition group-hover:translate-y-1">
						Clearwater Farms&nbsp;
					</span>
					<span className="text-md font-light text-nowrap transition group-hover:-translate-y-1">
						Unit 1
					</span>
				</Link>
				<div id="row1-nav" className="flex max-md:hidden">
					<MainNavigationMenu schedules={data.schedules} />
				</div>
				<div id="row1-profile" className="flex gap-1 md:max-lg:hidden">
					<ThemeSwitch
						id="row1-theme-switch"
						userPreference={data.requestInfo.userPrefs.theme}
					/>
					<UserProfile />
				</div>
			</div>
			<div id="row2-icons" className="flex md:hidden">
				<MainNavigationMenu schedules={data.schedules} />
			</div>
			<div
				id="row2-logo"
				className="hidden w-full justify-between p-1 lg:max-2xl:flex"
			>
				<Link to="/" className="group flex flex-wrap items-center leading-snug">
					<span className="text-lg font-bold transition group-hover:translate-y-1">
						Clearwater Farms&nbsp;
					</span>
					<span className="text-md font-light transition group-hover:-translate-y-1">
						Unit 1
					</span>
				</Link>
			</div>
			<div
				id="row2-profile"
				className="hidden w-full justify-between md:max-lg:flex"
			>
				<Link to="/" className="group flex flex-wrap items-center leading-snug">
					<span className="text-lg font-bold transition group-hover:translate-y-1">
						Clearwater Farms&nbsp;
					</span>
					<span className="text-md font-light transition group-hover:-translate-y-1">
						Unit 1
					</span>
				</Link>
				<div className="flex flex-row gap-1">
					<ThemeSwitch
						id="row2-theme-switch"
						userPreference={data.requestInfo.userPrefs.theme}
					/>
					<UserProfile />
				</div>
			</div>
		</header>
	)
}
